/**
 * @file Photo related fragments.
 */

import gql from 'graphql-tag';

export const PhotoUrlTypeFieldsPhoto = gql`
  fragment PhotoUrlTypeFieldsPhoto on PhotoURLType {
    url
    width
    height
    size_code
  }
`;

export const PhotoThumbnailsPhoto = gql`
  fragment PhotoThumbnailsPhoto on Photo {
    id
    thumbnail_urls {
      ...PhotoUrlTypeFieldsPhoto
    }
  }
  ${PhotoUrlTypeFieldsPhoto}
`;

export const PhotoFavoriteDetails = gql`
  fragment PhotoFavoriteDetails on Photo {
    id
    is_favorite
  }
`;

export const AlbumPhotoFavoriteDetails = gql`
  fragment AlbumPhotoFavoriteDetails on AlbumPhoto {
    id
    favorite_photos {
      total
    }
  }
`;

export const AlbumPhotoFaceHighlightDetails = gql`
  fragment AlbumPhotoFaceHighlightDetails on AlbumPhoto {
    id
    face_highlights(slice: { limit: 999 }) {
      total
      records {
        id
        face {
          id
        }
        rating
        type
      }
    }
  }
`;

export const PhotoFaceHighlightDetails = gql`
  fragment PhotoFaceHighlightDetails on Photo {
    id
    face_highlights(album_id: $album_id, slice: { limit: 999 }) {
      total
      records {
        id
        face {
          id
        }
        rating
        type
      }
    }
  }
`;

export const PhotoWatermarkThumbnailDetails = gql`
  fragment PhotoWatermarkThumbnailDetails on Photo {
    id
    watermarked_urls {
      url
      width
      height
      size_code
    }
  }
`;

export const PhotoForegroundDetails = gql`
  fragment PhotoForegroundDetails on Photo {
    id
    foreground {
      original_url {
        url
      }
      watermarked_original_url {
        url
      }
      thumbnail_urls {
        url
        width
        height
        size_code
      }
      watermarked_thumbnail_urls {
        url
        width
        height
        size_code
      }
    }
  }
`;

export const PhotoWallpaperWatermarkDetails = gql`
  fragment PhotoWallpaperWatermarkDetails on Photo {
    id
    wallpaper_watermark_urls {
      url
      size_code
      width
      height
    }
  }
`;
